<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-chip
                color="secondaryLighten2 secondary--text font-weight-bold"
                v-bind="attrs"
                v-on="on">
                {{currentYear}}
                <v-icon
                    right
                    small>
                    expand_more
                </v-icon>
            </v-chip>
        </template>
        <v-list>
            <v-list-item 
                :href="`https://${year}.dspolitical.com`"
                :key="year"
                target="_blank"
                v-for="year in years">
                {{year}}
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "year-toggle",
        computed: {
            currentYear(){
                if(this.isDevMode){
                    return '2024';
                } else {
                    return window.location.hostname.split('.')[0];
                }
            },
            isDevMode(){
                return process.env.NODE_ENV;
            },
            years(){
                let years = [ '2024','2022', '2020', '2018'];
                return years.filter(year => year != this.currentYear);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>